var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatButtonIconNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91671 12.25H18.0834M8.16671 21.5016H12.8334L18.0251 24.955C18.7951 25.4683 19.8334 24.92 19.8334 23.9866V21.5016C23.3334 21.5016 25.6667 19.1683 25.6667 15.6683V8.66829C25.6667 5.16829 23.3334 2.83496 19.8334 2.83496H8.16671C4.66671 2.83496 2.33337 5.16829 2.33337 8.66829V15.6683C2.33337 19.1683 4.66671 21.5016 8.16671 21.5016Z",
    stroke: "#292B30",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.75,
    cy: 5.25,
    r: 4.59375,
    fill: "#0073BB",
    stroke: "white",
    strokeWidth: 1.3125
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatButtonIconNotification);
export default __webpack_public_path__ + "static/media/chat-button-icon-notification.ae5982455bc95f0b55af8214c58e5368.svg";
export { ForwardRef as ReactComponent };